import { type TTeamCheckerFlowProps } from '@capsicum/socios-core';

import { ChooseYourTeams } from '../../../partners/ui/select-favourite-team/ChooseYourTeams';

import { Wrapper } from './FavoriteTeamCheckerFlow.styled';

export const FavouriteTeamRegistrationCheckerFlow = ({ onProceed }: TTeamCheckerFlowProps) => {
	return (
		<Wrapper>
			<ChooseYourTeams layout="widget" onSkip={onProceed} onSubmit={onProceed} />
		</Wrapper>
	);
};
